import React, { Component } from 'react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import './info-bar.css';

export class InfoBar extends Component {
  constructor(props) {
    super(props);
    this.makeCard = this.makeCard.bind(this);
  }

  makeCard = (elem) => {
    return (
      <Card key={elem.key} zDepth={0} style={{backgroundColor:'white',marginBottom:'10px'}}>
        <CardHeader

                     title={elem.title}
                     actAsExpander={true}
                     showExpandableButton={true}
                     titleColor="black"
                     titleStyle={{fontSize:'small', fontFamily:'open sans',backgroundColor:'white',width:'100%'}}
                     closeIconStyle={{color:'white'}}
                     style={{padding:'0px'}}

                     buttonStyle={{color:'white'}}
        />
        <CardText expandable={true}
                  style={{fontSize:'small',maxWidth:'85%', fontFamily:'open sans',padding:'0px', wordWrap: 'break-word',fontWeight:'lighter', hyphen: 'auto'}}
                  dangerouslySetInnerHTML={{__html: elem.content}}  >

        </CardText>
      </Card>
    );
  }

  render() {
    if(this.props.faq.length === 0){
      return (
        <div className="InfoBarGrey" id="hideInfoBar">
          <MuiThemeProvider muiTheme={getMuiTheme()}>
              <div className="InfoBarHeader">
                <a  href={`/contact/#contactform`} > Zum Kontaktformular  </a> </div>
          </MuiThemeProvider>
        </div>
      );
    }
    let items = this.props.faq.map(
      faqElem => this.makeCard(faqElem)
    );
    return (
      <div className="InfoBarGrey" id="hideInfoBar">
        <MuiThemeProvider muiTheme={getMuiTheme()}>
          <div>
            <br />
            {items}
         </div>
        </MuiThemeProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/info-bar.js